const initialState = {}

export default (state = initialState, action) => {
  switch (action.type) {
    case 'FETCH_CALENDAR_REQUEST':
      return {
        ...state,
        options: {
          calendarStatus: 'loading'
        },
        [action.payload.monthId]: {
          status: 'loading',
          lastLoadedDate: null,
          days: []
        }
      }

    case 'FETCH_CALENDAR_RANGE_DONE':
      return {
        ...state,
        options: {
          calendarStatus: 'loading'
        },
        [action.payload.monthId]: {
          status: 'loading',
          lastLoadedDate: action.payload.range_end,
          days: Array.from(state[action.payload.monthId] ? state[action.payload.monthId].days : []).concat(action.payload.days)
        }
      }

    case 'FETCH_CALENDAR_DONE':
      return {
        ...state,
        options: {
          calendarStatus: 'ready'
        },
        [action.payload.monthId]: {
          ...state[action.payload.monthId],
          status: 'ready',
          receivedAt: Date.now(),
          diagnostic_data: action.payload.diagnosticData
        }
      }

    case 'FETCH_CALENDAR_FAIL':
      return {
        ...state,
        options: {
          calendarStatus: 'error'
        },
        [action.payload.monthId]: {
          status: 'error',
          days: []
        }
      }

    case 'CLEAR_CALENDAR_DATA':
      return initialState

    default:
      return state
  }
}
